import {AxiosResponse} from 'axios';

export const extractFilenameFromResponse = (response: AxiosResponse): string => {
  const headerLine = response.headers['content-disposition'];
  const startFileNameIndex = headerLine?.indexOf('"') + 1;
  const endFileNameIndex = headerLine?.lastIndexOf('"');
  let filename = 'file.pdf';
  if (startFileNameIndex && endFileNameIndex) {

    filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
  }

  return decodeURI(filename);
};
